import React from 'react';
import { ResponsiveContainer, BarChart, LabelList, Bar, XAxis, CartesianGrid, Tooltip, YAxis, Label, Cell } from 'recharts';

const BrandSCatChart = ({ csat, title }) => {
    const colors = ["#cacaca", "var(--red)", "var(--gold)", "var(--green)", "var(--blue)"];
    const [hide, setHide] = React.useState(window.innerWidth < 768)

    function handleWindowSizeChange() {
        setHide(window.innerWidth < 768)
    }

    React.useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const width = (() => {
        let length = 0
        for (const item of csat) {
            if (length < item.name.length) length = item.name.length
        }
        return length * 7
    })();

    return (
        <ResponsiveContainer>
            <BarChart
                layout="vertical"
                data={csat}
            >
                <CartesianGrid stroke="none" />
                <XAxis domain={[0, 5]} ticks={[0, 1, 2, 3, 4, 5]} dataKey="value" type="number">
                    <Label value={`نمودار میزان رضایت ${title}`} offset={-9} position="insideBottom" />
                </XAxis>
                <YAxis dataKey="name" type="category" width={width} hide={!csat.length || hide} />
                <Tooltip formatter={value => ["مقدار", value.toFixed(1)]} />
                <Bar
                    minPointSize={0}
                    barSize={18}
                    dataKey="value"
                    fill="#1976d2"
                    fontFamily="sans-serif"
                    labelList={{ dataKey: "name", position: "insideLeft", fill: "#000" }}

                >
                    <LabelList dataKey="value" formatter={value => value.toFixed(1)} position="insideRight" fill="#fff" />
                    {csat.map((entry, index) => (
                        <Cell key={index} fill={colors[2]} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};

export default BrandSCatChart;
